/**
 * GoTo is a select dropdown that redirects the user to the option value (url).
 * Use this when designer wants dropdowns to work like links.
 *
 * Example markup:

<select class="js-goto">
  <option value="http://www.example.org">Example</option>
</select>

 */
class GoTo {
  constructor(element: HTMLElement) {

    if(element.nodeName === 'SELECT') {
      element.addEventListener('change', this.onSelectChange.bind(this));
    } else {
      console.warn('[GoTo] Unsupported element', element);
    }
  }

  onSelectChange(event: Event): void {
    const select = event.target as HTMLSelectElement;
    const url = select.value;

    if(url) {
      this.redirect(url);
    }
  }

  redirect(url: string): void {
    window.location.href = url;
  }
}

export function init(element: HTMLElement): void {
  console.log('goto.init()');
  new GoTo(element);
}

export default GoTo;
